module.exports = __webpack_public_path__ + "static/img/Gacha01.5b57996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha01.png
// module id = k7u0
// module chunks = 1